import { GeneralSettingsData } from 'data/types/settings';

export const normalizeGeneralSettings = (data: GeneralSettingsData) => ({
  username: data.username,
  restaurant: {
    name: {
      displayName: data.restaurant.name.displayName,
    },
  },
  owner: {
    name: {
      firstName: data.owner.name.firstName,
      lastName: data.owner.name.lastName,
      displayName: data.owner.name.displayName,
      phoneNumber: data.owner.name.phoneNumber,
      email: data.owner.name.email,
    },
    address: {
      addressLine1: data.address.addressLine1,
      addressLine2: data.address.addressLine2,
      city: data.address.city,
      state: data.address.state,
      zipCode: data.address.zipCode,
      coords: {
        latitude: data.address.coords.latitude,
        longitude: data.address.coords.longitude,
      },
    },
    printer: { copies: data.printer.copies },
  },
});

export type GeneralSettings = ReturnType<typeof normalizeGeneralSettings>;
